import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';

import {
  postPaymentsSubscriptionsCancelAutoRenew,
  type PostPaymentsSubscriptionsCancelAutoRenewParams,
  type PostPaymentsSubscriptionsCancelAutoRenewResponse,
} from '@services/PaymentsService';

export type UsePostPaymentsSubscriptionsCancelAutoRenewParams = {
  mutationOptions?: SWRMutationConfiguration<
    PostPaymentsSubscriptionsCancelAutoRenewResponse,
    unknown,
    string,
    PostPaymentsSubscriptionsCancelAutoRenewParams,
    PostPaymentsSubscriptionsCancelAutoRenewResponse
  >;
};

export const postPaymentsSubscriptionsCancelAutoRenewMutationKey =
  'post-payments-subscriptions-cancel-auto-renew';

export const usePostPaymentsSubscriptionsCancelAutoRenew = ({
  mutationOptions,
}: UsePostPaymentsSubscriptionsCancelAutoRenewParams = {}) => {
  const { trigger, ...swrResponse } = useSWRMutation<
    PostPaymentsSubscriptionsCancelAutoRenewResponse,
    unknown,
    string,
    PostPaymentsSubscriptionsCancelAutoRenewParams
  >(
    postPaymentsSubscriptionsCancelAutoRenewMutationKey,
    (_url, { arg }) => postPaymentsSubscriptionsCancelAutoRenew(arg),
    mutationOptions,
  );

  return {
    trigger,
    ...swrResponse,
  };
};
